import url from './url';



export default url(({ abTestName = ':abTestName' }) => `/ab-tests/${abTestName}`);
